import React, { Component } from 'react';
import ImageCard from "./components/ImageCard";
import Nav from "./components/Nav";
import Wrapper from "./components/Wrapper";
import Title from "./components/Title";
import Container from "./components/Container";
import Column from "./components/Column";
import Row from "./components/Row";
import images from "./image.json";


// Shuffle images
function randomImages(array) {
  for (let i = array.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
};
//fileTest
class App extends Component {

  state = {
    images,
    currentScore: 0,
    topScore: 0,
    guessStatus: "",
    clicked: []
  }

  handleClick = id => {
    if (this.state.clicked.indexOf(id) === -1) {
      this.handleIncrement();
      this.setState({ clicked: this.state.clicked.concat(id) });
    } else {
      this.handleReset();
    }
  };

  handleIncrement = () => {
    const newScore = this.state.currentScore + 1;
    this.setState({
      currentScore: newScore,
      guessStatus: "Keep Going!"
    });
    if (newScore >= this.state.topScore) {
      this.setState({ topScore: newScore });
    }
    else if (newScore === 12) {
      this.setState({ guessStatus: "You win!" });
    }
    this.handleShuffle();
  };

  handleReset = () => {
    this.setState({
      currentScore: 0,
      topScore: this.state.topScore,
      guessStatus: "Ha Ha you're wrong!!",
      clicked: []
    });
    this.handleShuffle();
  };

  handleShuffle = () => {
    let shuffledImages = randomImages(images);
    this.setState({ images: shuffledImages });
  };

  render() {
    return (
 
      <Wrapper>

        <Nav
          title="Clicky Game"
          score={this.state.currentScore}
          topScore={this.state.topScore}
          guessStatus={this.state.guessStatus}
        />

        <Title>
          Click on an classic Hip-Hop album to earn points! You loose if you click on any album more than once!
        </Title>

        <Container>
          <Row>
            {this.state.images.map(gameImage => (
              <Column size="md-3 sm-6">
                <ImageCard
                  key={gameImage.id}
                  handleClick={this.handleClick}
                  handleIncrement={this.handleIncrement}
                  handleReset={this.handleReset}
                  handleShuffle={this.handleShuffle}
                  id={gameImage.id}
                  image={gameImage.image}
                />
              </Column>
            ))}
          </Row>
        </Container>

      </Wrapper>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js